import { EPromoType } from '../../types/newbuilding';
import bankIcon from './icons/bank.svg';
import bonusIcon from './icons/bonus.svg';
import discountIcon from './icons/discount.svg';
import mortgageIcon from './icons/mortgage.svg';

export const PROMO_ICONS_MAP = new Map<EPromoType, string>([
  [EPromoType.Bank, bankIcon],
  [EPromoType.Bonus, bonusIcon],
  [EPromoType.Discount, discountIcon],
  [EPromoType.Mortgage, mortgageIcon],
]);
